module.exports = $bonelibs.PropTypes;


//////////////////
// WEBPACK FOOTER
// external "$bonelibs.PropTypes"
// module id = 1
// module chunks = 1 3 4 5 6 7 8 9 15